import ScrollTextSvg from '@assets/images/svg/scroll-text.svg';
import React from 'react';

export interface ScrollTextIconProps {
    size?: number;
    color?: string;
}

export function ScrollTextIcon({ size = 24, color = '#333333' }: ScrollTextIconProps) {
    return (
        <ScrollTextSvg width={size} height={size} color={color} />
    );
}

export default ScrollTextIcon;
